import { useState } from "react";
import ContentLayout from "../../components/contentLayout";
import DraftTable from "../../components/table/draftTable";
import ProposalTable from "../../components/table/proposalTable";
import Modal from "../../components/modal";
import NewProposal from "../../components/modal/newProposal";
import { Navigate, useNavigate } from "react-router-dom";
import Proposal from "./[id]"

const ProposalPage = () => {
  const navigate = useNavigate()
  const [openCreateNew, setOpenCreateNew] = useState(false);
  const [openView, setOpenView] = useState(false);

  const onCraeteNewProposal = () => setOpenCreateNew((open) => !open);

  const onViewOrEdit = () => navigate('/proposals/1')

  const [clientids, setIDs]= useState()

 
  return (
    <>
      <ContentLayout>
        <ProposalTable  onCraeteNew={onCraeteNewProposal} onView={onViewOrEdit} idsSetter={setIDs}/>
        <DraftTable onEdit={onViewOrEdit} />
      </ContentLayout>

      <Modal isOpen={openCreateNew} onOutsideClick={onCraeteNewProposal}>
        <NewProposal onCancel={onCraeteNewProposal} clients={clientids}/>
      </Modal>
    </>
  );
};

export default ProposalPage;
